var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6033 0H0V30L29 0H20.675L5.96505 15.0337V6.79401L12.6033 0Z",
    fill: "url(#paint0_linear_427_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9281 23.7678L8.02097 30H29V8.04494L23.0929 14.1573V23.7678H13.9281Z",
    fill: "url(#paint1_linear_427_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_4",
    x1: 14.5,
    y1: 0,
    x2: 14.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_4",
    x1: 14.5,
    y1: 0,
    x2: 14.5,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.acfe15baa2c3cdb0d56fdc6453788a79.svg";
export { ForwardRef as ReactComponent };